import { ShipmentCard } from './shipment-card';

const CardsByWeek = ({ week, data }) => {
    if (!data) { return null };

    const view = [];
    for (const p in data) {
        view.push(
            <ShipmentCard week={week} partnerData={data[p]} partner={p} key={`${week.label}-${p}`} />
        )
    }

    return (
        <>
            {view}
        </>

    )
}

export { CardsByWeek };
